const TwitterConfirmedAccount = ({ color }: any) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.77324 2.9367C10.8915 1.46194 13.1085 1.46194 14.2268 2.9367C14.8369 3.74138 15.8337 4.15428 16.8342 4.01672C18.6677 3.76463 20.2354 5.33231 19.9833 7.16584C19.8457 8.16627 20.2586 9.16309 21.0633 9.77324C22.5381 10.8915 22.5381 13.1085 21.0633 14.2268C20.2586 14.8369 19.8457 15.8337 19.9833 16.8342C20.2354 18.6677 18.6677 20.2354 16.8342 19.9833C15.8337 19.8457 14.8369 20.2586 14.2268 21.0633C13.1085 22.5381 10.8915 22.5381 9.77324 21.0633C9.16309 20.2586 8.16627 19.8457 7.16584 19.9833C5.33231 20.2354 3.76463 18.6677 4.01672 16.8342C4.15428 15.8337 3.74138 14.8369 2.9367 14.2268C1.46194 13.1085 1.46194 10.8915 2.9367 9.77324C3.74138 9.16309 4.15428 8.16627 4.01672 7.16584C3.76463 5.33231 5.33231 3.76463 7.16584 4.01672C8.16627 4.15428 9.16309 3.74138 9.77324 2.9367Z'
        fill='#1DA1F2'
      />
      <path
        d='M16 9L10.5 14.5L8 12'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default TwitterConfirmedAccount
